(function () {
  angular.module('MktzapApp.Factories')
    .factory('PdvService', PdvService);

  PdvService.$inject = ['$resource'];

  function PdvService ($resource) {
    return $resource(apiUrl + '/pdv', { puntoVenta: '@puntoVenta' }, {
      store: { method: 'POST', params: {}, isArray: false },
      update: { method: 'PATCH', params: {}, isArray: false },
      delete: { method: 'DELETE', params: {}, isArray: false },
      getAllPdvs: { url: apiUrl + '/pdv/get-all-pdvs', method: 'GET', params: {}, isArray: false },
      getPdvById: { url: apiUrl + '/pdv/get-pdv', method: 'GET', params: {}, isArray: false },
      getExistspuntoVenda: { url: apiUrl + '/pdv/get-pdv-exist/:puntoVenta', method: 'GET', params: {}, isArray: false }
    });
  }
})();